<div class="col-xl-9">
  <div class="card">
    <div class="card-body">
      <div class="border-bottom d-flex justify-content-between">
        <h3>Review PayOut Data ({{ basis ?? '' | capitalize }})</h3>
        <h4>4/4</h4>
      </div>
      <!--Compliance Summary-->
      <div class="d-flex justify-content-between pt-3">
        <p>
          Applicable Compliances:
          <ng-container *ngIf="hasValidCompliances(); else noCompliance">
            <ng-container *ngFor="let compliance of compliancesList | keyvalue">
              <span
                class="badge bg-soft-info me-1"
                *ngIf="compliance.key !== 'employerCapping' && compliance.value === true"
              >
                {{ compliance.key + '' | uppercase }}
              </span>
            </ng-container>
          </ng-container>

          <ng-template #noCompliance>
            <span>None</span>
          </ng-template>
        </p>
        <button
          class="btn btn-link text-primary text-decoration-underline p-0 border-0"
          (click)="goToScreen()"
        >
          Edit
        </button>
      </div>
      <!--/Compliance Summary-->

      <!--Salary Summary-->
      <table class="table datatable">
        <thead class="thead-light">
          <tr>
            <th>Payout Component</th>
            <th>Type</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of payoutData">
            <ng-container *ngIf="item[0] !== 'otherComponents'">
              <td style="word-wrap: break-word; white-space: normal">
                {{ item[0] | capitalize }}
              </td>
              <td>
                <span class="badge bg-soft-info">Earning</span>
              </td>
              <td>{{ item[1] | currency: currency ?? 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}</td>
            </ng-container>
          </tr>
          <ng-container *ngFor="let item of otherComponents">
            <tr *ngIf="item.componentType !== 'customDeductions'; else elseBlock">
              <td style="word-wrap: break-word; white-space: normal">
                {{ item.name }}
              </td>
              <td>
                <span class="badge bg-soft-info">{{
                  item.componentType === 'customDeductions' ? 'Deduction' : 'Earning'
                }}</span>
              </td>
              <td>
                {{
                  item.employerContribution
                    | currency: currency ?? 'INR' : 'symbol' : '1.0-0' : 'en-IN'
                }}
              </td>
            </tr>
            <ng-template #elseBlock>
              <tr>
                <td style="word-wrap: break-word; white-space: normal">
                  {{ item.name }} - Employer Contribution
                </td>
                <td>
                  <span class="badge bg-soft-info">{{
                    item.componentType === 'customDeductions' ? 'Deduction' : 'Earning'
                  }}</span>
                </td>
                <td>
                  {{
                    item.employerContribution
                      | currency: currency ?? 'INR' : 'symbol' : '1.0-0' : 'en-IN'
                  }}
                </td>
              </tr>
              <tr>
                <td style="word-wrap: break-word; white-space: normal">
                  {{ item.name }} - Employee Contribution
                </td>
                <td>
                  <span class="badge bg-soft-info">{{
                    item.componentType === 'customDeductions' ? 'Deduction' : 'Earning'
                  }}</span>
                </td>
                <td>
                  {{
                    item.employeeContribution
                      | currency: currency ?? 'INR' : 'symbol' : '1.0-0' : 'en-IN'
                  }}
                </td>
              </tr>
            </ng-template>
          </ng-container>
          <!--Add Special Allowances-->
          <tr>
            <td>CTC</td>
            <td><span class="badge bg-soft-info">Earning</span></td>
            <td>{{ ctc | currency: currency ?? 'INR' : 'symbol' : '1.0-0' : 'en-IN' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
